function resolveBuildVersion(env = {}) {
  return (
    env.VUE_APP_BUILD_VERSION ||
    env.VUE_APP_VERSION ||
    env.npm_package_version ||
    "dev"
  );
}

module.exports = {
  resolveBuildVersion,
};
